import EventCard from '../components/EventCard'
import technicalEvents from '../datas/technical.js'
import nonTechnicalEvents from '../datas/non-technical.js'
import { useParams } from 'react-router-dom'

export default function EventList() {

    const { type } = useParams()
    // console.log(type);

    const technical = technicalEvents.map(event => {
        return (<EventCard
            key={event.id}
            name={event.name}
            img={event.img}
            description={event.description}
            date={event.date}
            timings={event.timings}
        />)
    })    
    const nonTechnical = nonTechnicalEvents.map(event => {
        return (<EventCard
            key={event.id}
            name={event.name}
            img={event.img}
            description={event.description}
            date={event.date}
            timings={event.timings}
        />)
    })    
    
    return (<div className={type+'-events all-events'}>
        <div className="event-lists">
            {type==='technical' && technical}
            {type==='non-technical' && nonTechnical}
        </div>
    </div>)
}